import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

interface IPowerProps {
    title: string;
    value: number;
    maxValue: number;
    description?: string;
    children?: React.ReactNode;
}

interface IBarProps {
    width: string;
}

const Root = styled.div`
    
`;

const InfoBlock = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #363870;
    margin-bottom: 8px;
    justify-content: space-between;
`;

const Title = styled.div`
    color: #8082C5;
`;

const Progress = styled.div`
    background: #F1F2FE;
    border-radius: 4px;
    height: 8px;
    position: relative;
    overflow: hidden;
`;

const Bar = styled.div<IBarProps>`
    background: #7075E9;
    border-radius: 4px;
    height: 8px;
    position: absolute;
    top: 0;
    left: 0;
    width: ${({width}) => width || 'auto'};
    transition: width 1s ease-in-out;
`;

export default observer(function(props: IPowerProps) {
    return (
        <Root>
            <InfoBlock>
                <Title>{props.title}</Title>
                <div>{props.value} / {props.maxValue}</div>
            </InfoBlock>
            <Progress>
                <Bar width={(props.maxValue > 0 ? ((props.value || 0) / props.maxValue * 100) : 0).toFixed(2) + '%'} />
            </Progress>
            {props.children}
        </Root>
    );
});